import React from 'react';
interface StatusBadgeProps {
  status: string;
  type?: 'reward' | 'claim' | 'verification' | 'default';
  className?: string;
}
const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  type = 'default',
  className = ''
}) => {
  const getStatusColor = () => {
    // Reward statuses
    if (type === 'reward') {
      switch (status) {
        case 'Attivo':
          return 'bg-green-100 text-green-800';
        case 'Programmato':
          return 'bg-blue-100 text-blue-800';
        case 'In pausa':
          return 'bg-amber-100 text-amber-800';
        case 'Scaduto':
          return 'bg-gray-100 text-gray-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    }
    // Claim statuses
    if (type === 'claim') {
      switch (status) {
        case 'Completato':
        case 'Riscattato':
          return 'bg-green-100 text-green-800';
        case 'In attesa':
        case 'Pending':
          return 'bg-amber-100 text-amber-800';
        case 'Annullato':
        case 'Rifiutato':
          return 'bg-red-100 text-red-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    }
    // Verification statuses
    if (type === 'verification') {
      switch (status) {
        case 'Verificato':
        case 'Approvato':
          return 'bg-green-100 text-green-800';
        case 'In attesa':
        case 'Da verificare':
          return 'bg-amber-100 text-amber-800';
        case 'Rifiutato':
          return 'bg-red-100 text-red-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    }
    // Default
    return 'bg-gray-100 text-gray-800';
  };
  return <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getStatusColor()} ${className}`} data-id="element-1596">
      {status}
    </span>;
};
export default StatusBadge;